var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGestaoFerias(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gestao-ferias",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      enableBackground: "new 0 0 171 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gestao-ferias_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hJPeGW.tif_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127,137.6c-27.7,0-55.4,0-83,0c-0.2-0.1-0.4-0.2-0.7-0.2c-5.7-1.2-9.9-6-9.9-11.7c0-24.1-0.1-48.2,0-72.3 c0-4.8,2.4-8.3,6.6-10.6c1.8-1,3.7-1.4,5.7-1.4c1.6,0,3.2,0,4.8,0c0-2.8,0-5.4,0-8.1c2.7,0,5.4,0,8.2,0c0,2.7,0,5.4,0,8 c17.9,0,35.8,0,53.7,0c0-2.7,0-5.4,0-8c2.8,0,5.4,0,8.1,0c0,2.7,0,5.4,0,8.1c1.7,0,3.4,0,5,0c4,0.1,7.2,1.7,9.6,4.9 c1.3,1.7,1.9,3.7,2.5,5.7c0,25,0,49.9,0,74.9c-0.1,0.2-0.2,0.4-0.2,0.7c-1,4.5-3.7,7.6-8.1,9.3 C128.6,137.2,127.8,137.4,127,137.6z M129.5,71.7c-29.4,0-58.6,0-87.9,0c0,0.2,0,0.3,0,0.4c0,17.8,0,35.6,0,53.3 c0,2.3,1.8,4,4.1,4c4.5,0,9.1,0,13.6,0c0.2,0,0.3,0,0.5-0.1c2.6-12.4,12.9-20.6,24.3-21.2c5.5-0.3,10.7,1,15.4,3.9 c6.4,4.1,10.3,9.9,11.9,17.4c4.5,0,8.9,0,13.4,0c3.1,0,4.7-1.6,4.7-4.7c0-14.6,0-29.2,0-43.8C129.5,77.9,129.5,74.8,129.5,71.7z  M112.4,49.7c-18,0-35.9,0-53.8,0c0,2.7,0,5.3,0,8c-2.7,0-5.4,0-8.2,0c0-2.7,0-5.4,0-8.1c-1.7,0-3.2,0-4.8,0 c-2.4,0-4.1,1.8-4.1,4.1c0,2.2,0,4.3,0,6.5c0,1,0,2.1,0,3.1c29.4,0,58.6,0,87.9,0c0-3.4,0.1-6.7,0-10c0-1.9-1.5-3.5-3.4-3.7 c-1.8-0.2-3.6,0-5.6,0c0,2.7,0,5.4,0,8.1c-2.8,0-5.4,0-8.1,0C112.4,55.1,112.4,52.4,112.4,49.7z M102.9,129.4 c-1.7-6.7-8.5-13.5-18.1-13.2c-9.1,0.4-15.3,7.3-16.6,13.2C79.8,129.4,91.3,129.4,102.9,129.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.1,114.1c-1.4,2.4-2.7,4.7-4.1,7.1c-3.3-1.9-6.5-3.8-9.9-5.7c1.4-2.4,2.7-4.7,4.1-7 C52.5,110.3,55.8,112.2,59.1,114.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.5,103.2c2-3.3,4-6.5,6-9.7c2.3,1.4,4.6,2.8,6.9,4.2c-2,3.3-3.9,6.4-6,9.7 C104.1,106.1,101.8,104.7,99.5,103.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.9,103.2c-2.4,1.5-4.6,2.8-6.9,4.3c-2-3.2-3.9-6.4-5.9-9.7c2.3-1.4,4.6-2.8,6.9-4.3 C68,96.8,69.9,100,71.9,103.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.3,114.1c3.3-1.9,6.6-3.8,9.9-5.7c1.4,2.3,2.7,4.6,4.1,7c-3.3,1.9-6.5,3.8-9.9,5.7 C115,118.8,113.7,116.5,112.3,114.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.5,101.1c-2.7,0-5.3,0-8,0c0-3.8,0-7.5,0-11.3c2.6,0,5.3,0,8,0C89.5,93.5,89.5,97.3,89.5,101.1z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestaoFerias);
export default __webpack_public_path__ + "static/media/gestao-ferias.3c23c0385c262449d8dccd76f2b9356f.svg";
export { ForwardRef as ReactComponent };